import Button from "@material-ui/core/Button";
import red from "@material-ui/core/colors/red";
import Snackbar from "@material-ui/core/Snackbar";
import type { Theme } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";
import { useState } from "react";
import type { Submission } from "../../../../models/homework";
import { deleteSubmission } from "../../../../models/homework";
import DeleteDialog from "./Dialog";

const useStyles = makeStyles((theme: Theme) => ({
  redButton: {
    color: "white",
    backgroundColor: red[600],
    "&:hover": {
      backgroundColor: red[900],
    },
  },
}));

export default function Delete({
  submission,
  onDelete,
}: {
  submission: Submission;
  onDelete: () => void;
}) {
  const classes = useStyles();
  const [error, setError] = useState<string>();

  const handleDelete = () => {
    deleteSubmission(submission.uid, submission.lesson.lessonID)
      .then(
        () => {
          onDelete();
        },
        (e) => {
          switch (e?.response?.status) {
            default:
              setError("エラーが発生し、削除に失敗しました。");
              break;
          }
        }
      )
      .finally(() => {
        setOpen(false);
      });
  };

  const [open, setOpen] = useState<boolean>(false);
  const handleClick = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleSnackbarClose = () => {
    setError("");
  };

  return (
    <>
      <Button
        className={classes.redButton}
        variant="contained"
        onClick={handleClick}
      >
        削除する
      </Button>
      <DeleteDialog open={open} onClose={handleClose} onDelete={handleDelete} />
      <Snackbar open={!!error} onClose={handleSnackbarClose}>
        <Alert severity="error">{error}</Alert>
      </Snackbar>
    </>
  );
}
